import { render, staticRenderFns } from "./basicForm.vue?vue&type=template&id=21da1eee&scoped=true"
import script from "./basicForm.vue?vue&type=script&lang=js"
export * from "./basicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da1eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21da1eee')) {
      api.createRecord('21da1eee', component.options)
    } else {
      api.reload('21da1eee', component.options)
    }
    module.hot.accept("./basicForm.vue?vue&type=template&id=21da1eee&scoped=true", function () {
      api.rerender('21da1eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/contractLedger/components/basicForm.vue"
export default component.exports